/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import classnames from 'classnames';

import { tutorialAction, advanceExerciseStage } from './actions';
import { exerciseStages } from '../shared/constants';
import { Button } from '../components/Button';

const mapStateToAdvanceExerciseButtonProps = ({
   activeExercise: { currentStage, preparingSession, preparingChallenge },
   tutorial,
}) => ({
   isTutorial: currentStage === exerciseStages.tutorial,
   loading:
      preparingSession ||
      preparingChallenge ||
      currentStage === exerciseStages.challenge ||
      (currentStage === exerciseStages.tutorial &&
         tutorial?.tutorialDocument?.sections[tutorial.section].steps[
            tutorial.step
         ].exerciseStage == null),
});
const AdvanceExerciseButton = connect(mapStateToAdvanceExerciseButtonProps)(
   ({ isTutorial, className, children, loading, delay, onClick }) => {
      const [clickedWithDelay, setClickedWithDelay] = useState(false);
      const dispatch = useDispatch();

      const dispatchAction = (isTutorial, action) =>
         dispatch(isTutorial ? tutorialAction(action) : action);

      const handleClick = (e) => {
         if (onClick != null) {
            onClick(e);
         }
         setClickedWithDelay(false);
         dispatchAction(isTutorial, advanceExerciseStage());
      };

      return (
         <Button
            disabled={loading || clickedWithDelay}
            className={classnames(className, {
               'button-loading': loading || clickedWithDelay,
            })}
            type="button"
            onClick={
               !delay
                  ? handleClick
                  : () => {
                       setClickedWithDelay(true);
                       setTimeout(handleClick, 500);
                    }
            }
         >
            {children || 'Next'}
         </Button>
      );
   }
);

export { AdvanceExerciseButton };
